export default __webpack_public_path__ + "static/attribute_do-dark-dc6599eb4acc44762cd4a16407e1b1fb.png";